// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"114":"core","138":"catalog-group","661":"catalog-search","949":"cart"}[chunkId] + "." + {"114":"f72ce44a","138":"96f4ffee","661":"96f4ffee","949":"6fe712bf"}[chunkId] + ".css";
};